import * as React from 'react';
import './styles.scss';
const classNames = require('classnames')
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
    getCloseWorkkardOpenActivities,
    getCloseWorkkardOpenDiaries,
    getCloseWorkkardOpenNotifications,
    showTooltip,
    hideTooltip,
    closeWorkkardPostAction,
    getPermissionsForCloseWorkkard,
    changeDiarieDueDate,
    changeDiarieTitle,
    resetCloseWorkkardState
} from "../../containers/WorkkardDetail/actions/action";
import CheckBox from "../Checkbox";
import EditableHeading from "../EditableHeading";
import DiaryEditDueDateComp from './editDiaryDueDate';
import ConfirmationTextBox from '../ConfirmationPrompt';
import { useModules } from '../../utils/modules';
import NotificationCell from '../../containers/Header/Notification/notificationCell';
import { MiddlePanelConstant, CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE,openDiaryTitle, ErrorCode } from "../../containers/WorkkardDetail/constants";

import { hideDialogueBox } from "../DialogueBox/actions";
import Icon from "../../icons";
import { getResolutionName } from '../../containers/WorkkardDetail/utils';
import { addClass, mobileAndTabletcheck, removeClass } from '../../common/util';
import UserImage from '../UserImage/index';
import { isMobile } from '../../common/util';


let defaultJSON = require("../../i18n/default.json");

let getItem = (elem, elemArray) => {
    return { ...elem, checked: elemArray.indexOf((elem.Id || elem.ActivityId)) > -1 };
};

function getIdsArrAndModifiedObj(inArray) {
    inArray = JSON.parse(JSON.stringify(inArray));
    let tmpObj = {};
    let id = null;
    let tmpArr = [];
    _.forEach(inArray, function (item) {
        id = (item.Id) ? item.Id : item.id;
        if (id === undefined) { id = item.ActivityId; }
        tmpArr.push(id);
        tmpObj[id] = item;
    });
    return { idArr: tmpArr, obj: tmpObj };
}

const CloseWorkkard = (props) => {
    const { isModuleEnabled } = useModules();
    const dispatch = useDispatch();
    const closeWorkkard = useSelector(state => state.workkardDetail.closeWorkkard);
    const claimActivities = useSelector(state => state.workkardDetail.activityListing.activities);
    const requestPayloadRef = React.useRef({ wkkdID: 0, closingtext: "", outActCount: 0, intActCount: 0 });
    const activityMasterDataRef = React.useRef({});
    const diaryMasterDataRef = React.useRef({});
    const notificationMasterDataRef = React.useRef({});
    const getActivityDatajsonRef = React.useRef({ "skip": "0", "take": "30" });
    const tmpRef = React.useRef(null);

    const [closingItems, setClosingItems] = React.useState([
        { title: "Open Activities", key: 'activity', iconName: 'workkardActivity', count: 0, outActCount: 0 },
        { title: "Open Diaries", key: 'diary', iconName: 'diaries', count: 0 },
        { title: "Unread Notifications", key: 'notification', iconName: 'bell', count: 0 }
    ]);
    const [selectedTab, setSelectedTab] = React.useState('activity');
    const [selectedActivities, setSelectedActivities] = React.useState([]);
    const [selectedDiaries, setSelectedDiaries] = React.useState([]);
    const [selectedNotification, setSelectedNotification] = React.useState([]);
    const [diariesData, setDiariesData] = React.useState({});
    const [activitiesData, setActivitiesData] = React.useState({});
    const [closeWorkkardConfimationMessage, setCloseWorkkardConfimationMessage] = React.useState("");
    const [closeWorkkardWarningMessage, setCloseWorkkardWarningMessage] = React.useState("");
    const [closeWorkkardErrorMessage, setCloseWorkkardErrorMessage] = React.useState("");
    const [canCloseWorkkard, setCanCloseWorkkard] = React.useState(true);
    const [ownerassigneeinfokey, setOwnerassigneeinfokey] = React.useState(-1);
    const [editDiaryTitle, setEditDiaryTitle] = React.useState(0);

    const closingItemsRef = React.useRef(closingItems);
    closingItemsRef.current = closingItems;

    React.useEffect(() => {
        getActivityDatajsonRef.current["wkkdID"] = props.workkardId;
        requestPayloadRef.current["wkkdID"] = props.workkardId;
        requestPayloadRef.current["actId"] = props.actId;

        setActivitiesData(claimActivities.filter(x => !["close", "closemidterm"].includes(x.status)));
        //dispatch(getCloseWorkkardOpenActivities(getActivityDatajsonRef.current));
        dispatch(getCloseWorkkardOpenDiaries(getActivityDatajsonRef.current));
        dispatch(getCloseWorkkardOpenNotifications(getActivityDatajsonRef.current));

        return () => { dispatch(resetCloseWorkkardState()); };
    }, []);

    React.useEffect(() => {
        const { activitiesData: actData, diariesData: dData, notificationData: nData } = closeWorkkard;
        requestPayloadRef.current["outActCount"] = actData.outActCount;
        if (actData && actData.data && actData.data.length && !closingItemsRef.current[0].count) {
            requestPayloadRef.current["intActCount"] = actData.count;
            let tmp = closingItemsRef.current.slice();
            tmp[0].count = actData.data.length;
            const extractedData = getIdsArrAndModifiedObj(actData.data);
            activityMasterDataRef.current = extractedData.obj;
            setClosingItems(tmp);
            setSelectedActivities(extractedData.idArr);
            setActivitiesData(activityMasterDataRef.current);
        }
        if (dData && dData.data && dData.data.length && !closingItemsRef.current[1].count) {
            let tmp = closingItemsRef.current.slice();
            tmp[1].count = dData.data.length;
            const extractedData = getIdsArrAndModifiedObj(dData.data);
            diaryMasterDataRef.current = extractedData.obj;
            setClosingItems(tmp);
            setSelectedDiaries(extractedData.idArr);
            setDiariesData(diaryMasterDataRef.current);
        }
        if (nData && nData.data && nData.data.length && !closingItemsRef.current[2].count) {
            let tmp = closingItemsRef.current.slice();
            tmp[2].count = nData.data.length;
            const extractedData = getIdsArrAndModifiedObj(nData.data);
            notificationMasterDataRef.current = extractedData.obj;
            setClosingItems(tmp);
            setSelectedNotification(getIdsArrAndModifiedObj(nData.data).idArr);
        }
    }, [closeWorkkard]);

    React.useEffect(() => {
        let modalDiv = document.querySelector(".ReactModal__Content");
        removeClass(modalDiv, "confirmModal");
        if (mobileAndTabletcheck() && closeWorkkardConfimationMessage) {
            addClass(modalDiv, "confirmModal");
        } else if (closeWorkkardConfimationMessage) {
            removeClass(modalDiv, "large");
            removeClass(modalDiv, "fullView");
            removeClass(modalDiv, "modalAlignFromTop");
            addClass(modalDiv, "medium");
            addClass(modalDiv, "confirmModal");
        } else if (!mobileAndTabletcheck()) {
            removeClass(modalDiv, "medium");
            addClass(modalDiv, "large");
            addClass(modalDiv, "fullView");
            addClass(modalDiv, "modalAlignFromTop");
        }
    }, [closeWorkkardConfimationMessage]);

    const onTabClick = (tabKey) => { setSelectedTab(tabKey); };

    const handleMultiActivityCheckBoxClick = (data) => {
        if (!data.checked) {
            setSelectedActivities(getIdsArrAndModifiedObj(closeWorkkard.activitiesData.data).idArr);
            setCanCloseWorkkard(true);
        } else {
            setSelectedActivities([]);
            setCanCloseWorkkard(false);
        }
    };

    const handleMultiDiaryCheckBoxClick = (data) => {
        if (!data.checked) { setSelectedDiaries(getIdsArrAndModifiedObj(closeWorkkard.diariesData.data).idArr); }
        else { setSelectedDiaries([]); }
    };

    const handleMultiNotificationCheckBoxClick = (data) => {
        if (!data.checked) { setSelectedNotification(getIdsArrAndModifiedObj(closeWorkkard.notificationData.data).idArr); }
        else { setSelectedNotification([]); }
    };

    const handleActivityCheckboxClick = (data) => {
        let tmpActArr = selectedActivities.slice();
        const index = tmpActArr.indexOf(parseInt(data.ActivityId));
        if (!data.checked && index == -1) { tmpActArr.push(parseInt(data.ActivityId)); }
        else if (index >= -1) { tmpActArr.splice(index, 1); }
        setSelectedActivities(tmpActArr);
        setCanCloseWorkkard(tmpActArr.length > 0 ? true : false);
    };

    const handleDiaryCheckboxClick = (data) => {
        let tmpDiaryArr = selectedDiaries.slice();
        const index = tmpDiaryArr.indexOf(parseInt(data.Id));
        if (!data.checked && index == -1) { tmpDiaryArr.push(parseInt(data.Id)); }
        else if (index >= -1) { tmpDiaryArr.splice(index, 1); }
        setSelectedDiaries(tmpDiaryArr);
    };

    const handleNotificationCheckboxClick = (data) => {
        let tmpDiaryArr = selectedNotification.slice();
        const index = tmpDiaryArr.indexOf(parseInt(data.Id));
        if (!data.checked && index == -1) { tmpDiaryArr.push(parseInt(data.Id)); }
        else if (index >= -1) { tmpDiaryArr.splice(index, 1); }
        setSelectedNotification(tmpDiaryArr);
    };

    const updateDiariesData = (tmpObj) => {
        const tmp = Object.assign({}, diariesData, { [tmpObj.Id]: tmpObj });
        diaryMasterDataRef.current = tmp;
        setDiariesData(tmp);
    };

    const onDiaryTitleEditCLick = (data, id) => {
        let tmpObj = Object.assign({}, diariesData[id], { Title: data });
        const payload = { cid: tmpObj.Id, title: data, todoId: id };
        dispatch(changeDiarieTitle(payload));
        updateDiariesData(tmpObj);
        setEditDiaryTitle(0);
        // dispatch(hideTooltip());
    };

    const onDiaryDueDateEditCLick = (event, item) => {
        dispatch(showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: true,
            showOnClick: true,
            toolTipClassName: 'toolTipCommentBox',
            childComponent: <DiaryEditDueDateComp onSaveBtnClick={onDiaryDueDateSaveClick} onCancelBtnClick={() => dispatch(hideTooltip())} data={item} />
        }));
    };

    const onDiaryDueDateSaveClick = (data, payload) => {
        dispatch(hideTooltip());
        let tmpObj = Object.assign({}, diariesData[data.Id], data, { Title: diariesData[data.Id].Title });
        dispatch(changeDiarieDueDate(payload));
        updateDiariesData(tmpObj);
    };

    const onSuccess = (status) => {
        if (status == ErrorCode.Success) {
            dispatch(hideDialogueBox());
        } else if (status == ErrorCode.ActionDenied) {
            setCloseWorkkardConfimationMessage("");
            setCloseWorkkardErrorMessage(closeWorkkard.errorMessage);
        }
    };

    const onContinueClick = () => {
        if (canCloseWorkkard) {
            let activitiesDataArr = [];
            let diariesDataArr = [];
            let notificationDataArr = [];
            if (selectedActivities.length) {
                selectedActivities.map((activityId) => {
                    activityMasterDataRef.current[activityId]["Checked"] = true;
                    activitiesDataArr.push(activityId);
                });
            }
            if (selectedDiaries.length) {
                selectedDiaries.map((dId) => {
                    diaryMasterDataRef.current[dId]["Checked"] = true;
                    diariesDataArr.push(dId);
                });
            }
            if (selectedNotification.length) {
                selectedNotification.map((auId) => {
                    notificationMasterDataRef.current[auId]["Checked"] = true;
                    notificationDataArr.push(auId);
                });
            }
            tmpRef.current = Object.assign({}, {
                close_workkard_data: requestPayloadRef.current,
                activities_data: {
                    activityIds: JSON.stringify(activitiesDataArr),
                    isBulkNotificationOff: false,
                    noteText: encodeURIComponent(requestPayloadRef.current["closingtext"]),
                },
                diaries_data: { validDiaryIds: JSON.stringify(diariesDataArr), isBulkNotificationOff: false },
                notification_data: { status: 2, activityUpdateIds: selectedNotification.join(','), resetCounter: false },
                callback: (status) => onSuccess(status)
            });
            var msg = "Are you sure you want to close this workkard?";
            if (activitiesDataArr.length > 0 && (activitiesDataArr.length != Object.keys(activitiesData).length)) {
                msg = "This Workkard will not close due to some open Activities. Do you still want to proceed?";
            }
            setCloseWorkkardConfimationMessage(msg);
        }
    };

    const onConfirmButtonClick = () => { dispatch(closeWorkkardPostAction(tmpRef.current)); };

    const onConfirmErrorMsgClick = () => {
        setCloseWorkkardConfimationMessage(null);
        setCloseWorkkardWarningMessage(null);
        setCloseWorkkardErrorMessage(null);
        dispatch(hideDialogueBox());
    };

    const onClose = () => { dispatch(hideDialogueBox()); };

    const onEditClick = (event, tmp) => {
        dispatch(showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: true,
            showOnClick: true,
            childComponent: <EditableHeading isEditable={true} headingRequired={true} id={tmp.Id} heading={tmp.Title} onHeadingEdited={onDiaryTitleEditCLick} isOpen={true} editableHeadingCancelClick={() => dispatch(hideTooltip())} />
        }));
    };

    const renderLabels = (checked, type) => {
        let elm = <div className="selected_items_heading_txt"><FormattedMessage id={`close_activity.${type}`} defaultMessage={defaultJSON[`close_activity.${type}`]} /></div>;
        return { checked: checked, label: elm };
    };

    const CLOSE_WORKKARD_TAB_MODULE_KEY = {
        activity: "workkards.close_workkard.open_activities",
        diary: "workkards.close_workkard.open_diaries",
        notification: "workkards.close_workkard.unread_notifications",
    };

    const renderTabs = () => (
        <div className="tabNav">
            <div className="tabs">
                {closingItems.map((item, index) => {
                    if (CLOSE_WORKKARD_TAB_MODULE_KEY[item.key] && !isModuleEnabled(CLOSE_WORKKARD_TAB_MODULE_KEY[item.key])) {
                        return null;
                    }
                    let showtabs = (!isMobile() || (item.key == selectedTab));
                    return (
                        <>
                            <a key={item.key} href="javascript:void(0);" className={classNames({ active: (item.key == selectedTab) })} onClick={(e) => { onTabClick(item.key); }}>
                                <Icon name={item.iconName} className="icon" />
                                {showtabs && <>{item.title}<span className="count">&nbsp; ({item.count}) </span></>}
                            </a>
                        </>
                    );
                })}
            </div>
        </div>
    );

    const renderOpenActivities = () => {
        const tempActivities = activitiesData;
        return (
            (tempActivities && Object.keys(tempActivities).length)
                ?
                (
                    <>
                        <div id="dvActivitySection" className="closeWorkkardCard">
                            <div className="headSticky rowSpaceBetween alignMiddle">
                                <a className="flexGrow"><CheckBox handleCheckbox={handleMultiActivityCheckBoxClick} item={{ checked: selectedActivities.length === closeWorkkard.activitiesData.data.length, label: "Selected activities will get Closed." }} /></a>
                                <div className="ownerHeading">
                                    <div className="ownerAssignee rowSpaceBetween">
                                        <span>Owner</span>
                                        <span>Assignee</span>
                                    </div>
                                </div>
                            </div>
                            <ul className="scrollArea">
                                {Object.keys(tempActivities).map((item, key) => {
                                    const tmp = tempActivities[item];
                                    let isownerassigneesame = tmp.activityAssigneeUserName ? (tmp.activityOwnerUserFirstName == tmp.activityAssigneeUserFirstName) && (tmp.activityOwnerUserLastName == tmp.activityAssigneeUserLastName) : false;
                                    return (
                                        <li className="alignStart dFlex" key={tmp.activityId}>
                                            <div className="activityTitle alignMiddle"><CheckBox cssClass={"activityStart"} key={key} item={getItem(tmp, selectedActivities)} handleCheckbox={handleActivityCheckboxClick} /></div>
                                            <div className="openAssign flexGrow colFlex">
                                                <div className='rowSpaceBetween assignColumn'>
                                                    <div className="rowSpaceBetween">
                                                        <span className="assignmentDiaries mr"> {tmp.activityName} <em>-</em> </span>
                                                        <label className="activity_created_date"> {tmp.CreatedDate}</label>
                                                    </div>
                                                    <div className="rowSpaceBetween flexGrow">
                                                        <span className={`status ${getResolutionName(tmp.status.toLowerCase(), true)} statusSpace`}>{getResolutionName(tmp.status.toLowerCase(), false)}{tmp.status === "In Progress" && " (" + tmp.percentProgress + "% DONE)"}</span>
                                                        <div className="rowFlex posBottom alignRight activityUser" onClick={() => setOwnerassigneeinfokey(key)} onMouseLeave={() => setOwnerassigneeinfokey(-1)}>
                                                            {(isMobile() && ownerassigneeinfokey == key) &&
                                                                <div className="exz-tooltip" key={key}>
                                                                    <div className="colFlex">
                                                                        <div className="userInfo  alignMiddle">
                                                                            <UserImage profileUrl={tmp.activityOwnerImage} size="32" profileName={`${tmp.activityOwnerUserFirstName} ${tmp.activityOwnerUserLastName}`} />
                                                                            <span className="ml">
                                                                                <span className="name">{tmp.activityOwnerUserFirstName} {tmp.activityOwnerUserLastName}</span>
                                                                                <label>{isownerassigneesame ? 'Activity Owner & Assignee' : 'Activity Owner'}</label>
                                                                            </span>
                                                                        </div>
                                                                        {!isownerassigneesame && <div className="userInfo flexWrap alignMiddle mt">
                                                                            <UserImage profileUrl={tmp.activityAssigneeImage} size="32" profileName={`${tmp.activityAssigneeUserFirstName} ${tmp.activityAssigneeUserLastName}`} />
                                                                            <span className="ml">
                                                                                <span className="name">{tmp.activityAssigneeUserName ? tmp.activityAssigneeUserFirstName + ' ' + tmp.activityAssigneeUserLastName : tmp.assigneeOrgName}</span>
                                                                                <label>Activity Assignee</label>
                                                                            </span>
                                                                        </div>}
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="badges badgesSmall overlap">
                                                                <UserImage profileUrl={tmp.activityOwnerImage} size="24" profileName={`${tmp.activityOwnerUserFirstName} ${tmp.activityOwnerUserLastName}`} />
                                                                <span className="activityCreator">{tmp.activityOwnerUserFirstName} {tmp.activityOwnerUserLastName}</span>
                                                            </div>
                                                            {tmp.activityAssigneeUserName ?
                                                                <div className="badges badgesSmall">
                                                                    <UserImage profileUrl={tmp.activityAssigneeImage} size="24" profileName={`${tmp.activityAssigneeUserFirstName} ${tmp.activityAssigneeUserLastName}`} />
                                                                    <span className="activityCreator">{tmp.activityAssigneeUserFirstName} {tmp.activityAssigneeUserLastName}</span>
                                                                </div>
                                                                :
                                                                <div className="badges badgesSmall"><img className="" src={tmp.assigneeOrgImage} style={{ height: '24px', width: '24px' }} /><span className="activityCreator">{tmp.assigneeOrgName}</span></div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="alignMiddle"><label className="mr">due on</label> <span className="red">{tmp?.dueDate}</span></div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </>
                )
                :
                (
                    <div className="inner_container_area">
                        <div className="error_m alignMiddle">
                            <div className="emptyScreen noDataFound"><Icon name="EmptySearchActivity" className="" /><br /><label><FormattedMessage id="close_activity.noactivities" defaultMessage={defaultJSON['close_activity.noactivities']} /></label></div>
                        </div>
                    </div>
                )
        );
    };

    const renderOpenDiaries = () => {
        const tempDiaries = diariesData;
        return (
            (tempDiaries && Object.keys(tempDiaries).length)
                ?
                (
                    <div className="" id="dvOpenDiaries">
                        <div className="rowSpaceBetween headSticky alignMiddle">
                            <div className="activityTitle alignMiddle">
                                <CheckBox cssClass={"activityStart"} handleCheckbox={handleMultiDiaryCheckBoxClick} item={renderLabels(selectedDiaries.length === closeWorkkard.diariesData.data.length, 'heading')} />
                            </div>
                            <div className="due_date_label wth-1 gray dueDate"><div className="emptyScreen noDataFound"><Icon name="emptyparty" className="" /><label><FormattedMessage id="due_date_label" defaultMessage={defaultJSON['due_date_label']} /></label></div></div>
                        </div>
                        <ul className="scrollArea">
                            {Object.keys(tempDiaries).map((itemId, index) => {
                                const tmp = tempDiaries[itemId];
                                return (
                                    <li className={`${mobileAndTabletcheck() ? "dFlex" : "alignMiddle"}`} key={tmp.Id}>
                                        <>
                                            <div className="activityTitle"><CheckBox cssClass={"activityStart"} item={getItem(tmp, selectedDiaries)} handleCheckbox={handleDiaryCheckboxClick} /></div>
                                            <div className="openDiariesSummary flexGrow">
                                                <div className="diariesOwned">
                                                    <span className="alignMiddle">
                                                        {editDiaryTitle && editDiaryTitle == tmp.Id ?
                                                            <EditableHeading isEditable={true} headingRequired={true} id={tmp.Id} heading={tmp.Title} onHeadingEdited={onDiaryTitleEditCLick} isOpen={true} editableHeadingCancelClick={() => setEditDiaryTitle(0)} /> :
                                                            <span title={tmp.Title}>{tmp.Title.length > openDiaryTitle.maxLengthToTruncate ? tmp.Title.substring(openDiaryTitle.startIndexOfSubstringTruncate, openDiaryTitle.endIndexOfSubstringTruncate) + "..." : tmp.Title}
                                                                <span className="iconRipple ml mr alignMiddle"><a className="flexGrow" onClick={(e) => { setEditDiaryTitle(tmp.Id); }}><Icon name="editActive" className="icon mr ml ttController" /></a></span>
                                                            </span>
                                                        }
                                                    </span>
                                                    {/* <span  onClick={ (event)=>onEditClick(event,tmp) }className="edit_icon spnEditDueDate"></span> */}
                                                    <span className="alignMiddle">
                                                        added to <span className="ml"> {tmp.Module.toLowerCase() === "activity" ? <span class="badges actSymbol">A</span> : <span class="badges wkSymbol ">W</span>}</span>
                                                        {
                                                            tmp.WkName == null ?
                                                                <span className="mr ml" title={tmp.ActTitle}>{tmp.ActTitle.length > openDiaryTitle.maxLengthToTruncate ? tmp.ActTitle.substring(openDiaryTitle.startIndexOfSubstringTruncate, openDiaryTitle.endIndexOfSubstringTruncate) + "..." : tmp.ActTitle}</span>
                                                                :
                                                                <span className="mr ml" title={tmp.WkName}>{tmp.WkName.length > openDiaryTitle.maxLengthToTruncate ? tmp.WkName.substring(openDiaryTitle.startIndexOfSubstringTruncate, openDiaryTitle.endIndexOfSubstringTruncate) + "..." : tmp.WkName}</span>
                                                        }
                                                    </span>
                                                </div>
                                                <label>
                                                    <DiaryEditDueDateComp onSaveBtnClick={onDiaryDueDateSaveClick} className={"react-datepicker__triangle animated faster fadeInUpx2"} data={tmp} />
                                                    {/* <span className="editdate">{tmp.strDueDate}</span>
                                                    <span onClick={(e) => {onDiaryDueDateEditCLick(e, tmp);}} className="edit_icon spnEditDueDate"></span> */}
                                                </label>
                                            </div>
                                        </>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )
                :
                (
                    <div className="inner_container_area">
                        <div className="error_m alignMiddle">
                            <div className="emptyScreen noDataFound"><Icon name="Emptydiary" className="" /><br /><label><FormattedMessage id="close_activity.error" defaultMessage={defaultJSON['close_activity.error']} /></label></div>
                        </div>
                    </div>
                )
        );
    };

    const renderNotification = () => (
        (closeWorkkard && closeWorkkard.notificationData && closeWorkkard.notificationData.data && closeWorkkard.notificationData.data.length)
            ?
            (
                <div id="dvUnreadNotifications" className="">
                    <div className="rowSpaceBetween headSticky alignMiddle">
                        <div className="activityTitle alignMiddle"><CheckBox cssClass={"activityStart"} handleCheckbox={handleMultiNotificationCheckBoxClick} item={renderLabels(selectedNotification.length === closeWorkkard.notificationData.data.length, 'mark_heading')} /></div>
                    </div>
                    <ul className="scrollArea">
                        {closeWorkkard.notificationData.data.map((item, index) => (
                            <li className="dFlex" key={item.Id}>
                                <div className="activityTitle"><CheckBox cssClass={"activityStart"} item={getItem(item, selectedNotification)} handleCheckbox={handleNotificationCheckboxClick} /></div>
                                <div className='openAssign flexGrow colFlex'>
                                    <div className="rowSpaceBetween flexGrow">
                                        <NotificationCell data={item} extraData={{ displayMarkReadIcon: false, displayProfilePic: false, displayTriggerByName: false }} onCellClick={() => false} />
                                        <div className="rowFlex posBottom alignRight activityUser" onClick={() => setOwnerassigneeinfokey(index)} onMouseLeave={() => setOwnerassigneeinfokey(-1)}>
                                            {(isMobile() && ownerassigneeinfokey == index) &&
                                                <div className="exz-tooltip" key={index}>
                                                    <div className="colFlex">
                                                        <div className="userInfo  alignMiddle">
                                                            <UserImage profileUrl={item.TriggeredByProfileImage} size="32" profileName={`${item.TriggeredByFullName.split(' ')[0]} ${item.TriggeredByFullName.split(' ')[1]}`} />
                                                            <span className="ml"><span className="name">{item.TriggeredByFullName}</span></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="badges badgesSmall overlap">
                                                <UserImage profileUrl={item.TriggeredByProfileImage} size="24" profileName={`${item.TriggeredByFullName.split(' ')[0]} ${item.TriggeredByFullName.split(' ')[1]}`} />
                                                <span className="activityCreator">{item.TriggeredByFullName}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )
            :
            (
                <div className="inner_container_area">
                    <div className="error_m alignMiddle">
                        <div className="emptyScreen noDataFound"><Icon name="Emptyowner" className="" /><label><FormattedMessage id="close_activity.no_notification" defaultMessage={defaultJSON['close_activity.no_notification']} /></label></div>
                    </div>
                </div>
            )
    );

    const renderCommentBox = () => (
        <div className="commentSticky colFlex">
            <textarea onChange={(e) => { requestPayloadRef.current["closingtext"] = e.target.value; }} placeholder="Any comments here will be saved to Workkard and each Activity being closed."></textarea>
            <div className="closeAlert mt__1 mb">
                <span className=" alignRight flexGrow">
                    <button className={`btn buttonGradient ${!canCloseWorkkard ? 'disabled' : ''}`} onClick={onContinueClick}>Continue</button>
                    <button className="btn link mrNone" type="button" onClick={onClose}>Cancel</button>
                </span>
            </div>
        </div>
    );

    if (closeWorkkardConfimationMessage != "" && closeWorkkardConfimationMessage != null) {
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    message={closeWorkkardConfimationMessage}
                    onConfirmClick={() => onConfirmButtonClick()}
                    onCancelClick={() => setCloseWorkkardConfimationMessage(null)}
                    bothButton={true}
                    middleText={''}
                />
            </div>
        );
    }
    if (closeWorkkardErrorMessage != "" && closeWorkkardErrorMessage != null) {
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    header={"Cannot Close Workkard!"}
                    message={closeWorkkardErrorMessage}
                    confirmationText={"Close"}
                    hideCancel={true}
                    onConfirmClick={() => { onConfirmErrorMsgClick(); }}
                />
            </div>
        );
    }
    return (
        <>
            <div className="modalHeader alignMiddle CloseHeader">
                <h1>{MiddlePanelConstant.CloseWorkkardText}</h1>
                <a className="alignMiddle alignRight Close" href="javascript:void(0)" onClick={onClose}><Icon name="close" className="icon" /></a>
            </div>
            <div className="modalBody container close_activity_popup closeWorkkardPopup">
                <div className="info_txt toast toastList"><Icon name="info" className="icon mr" /><FormattedMessage id="close_activity.info_txt" defaultMessage={defaultJSON['close_activity.info_txt']} />
                </div>
                {renderTabs()}
                <div className="ModalinnerContainer">
                    {(selectedTab == "activity") && isModuleEnabled("workkards.close_workkard.open_activities") && renderOpenActivities()}
                    {(selectedTab == "diary") && isModuleEnabled("workkards.close_workkard.open_diaries") && renderOpenDiaries()}
                    {(selectedTab == "notification") && isModuleEnabled("workkards.close_workkard.unread_notifications") && renderNotification()}
                </div>
                {renderCommentBox()}
            </div>
        </>
    );
};

export default CloseWorkkard;